import { createBrowserRouter, Navigate } from "react-router-dom";
import { AdminLocaleLayout } from "./locale";
import { ProtectedLayout } from "./ProtectedLayout";
import { adminRoutes } from "../modules/admins/routes";
import { appConfigRoutes } from "../modules/app-configs/routes";
import { featureFlagRoutes } from "../modules/feature-flags/routes";
import { areaRoutes } from "../modules/areas/routes";
import { authRoutes } from "../modules/auth/routes";
import { dashboardRoutes } from "../modules/dashboard/routes";
import { integrationLogRoutes } from "../modules/integration-logs/routes";
import { profileRoutes } from "../modules/profile/routes";
import { sellerRoutes } from "../modules/sellers/routes";
import { storeRoutes } from "../modules/stores/routes";
import { subscriptionRoutes } from "../modules/subscriptions/routes";
import { themeRoutes } from "../modules/themes/routes";

export const adminRouter = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/ar/admin/login" replace />,
  },
  {
    path: "/:locale",
    element: <AdminLocaleLayout />,
    children: [
      ...authRoutes,
      {
        path: "admin",
        element: <ProtectedLayout />,
        children: [
          ...dashboardRoutes,
          ...profileRoutes,
          ...sellerRoutes,
          ...themeRoutes,
          ...adminRoutes,
          ...appConfigRoutes,
          ...featureFlagRoutes,
          ...areaRoutes,
          ...storeRoutes,
          ...subscriptionRoutes,
          ...integrationLogRoutes,
        ],
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/ar/admin/login" replace />,
  },
]);
